import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';


@Injectable({ providedIn: 'root' })
export class FieldFormHelperService {


  buildValidatorsFromStruct(structField: any): ValidatorFn[] {
    const validators: ValidatorFn[] = [];

    if (structField?.nullable === false) {
      validators.push(Validators.required);
    }

    const patternFromField = this.toValidRegexPattern(structField?.pattern);
    if (patternFromField) {
      validators.push(Validators.pattern(patternFromField));
    }

    const meta = structField?.validators;
    if (Array.isArray(meta)) {
      meta.forEach((v: any) => {
        const type = (v?.type || '').toString().trim().toLowerCase();
        const val = v?.value;

        switch (type) {
          case 'pattern': {
            const regex = this.toValidRegexPattern(val);
            if (regex) validators.push(Validators.pattern(regex));
            break;
          }
          case 'min': {
            const min = Number(val);
            if (!Number.isNaN(min)) validators.push(Validators.min(min));
            break;
          }
          case 'max': {
            const max = Number(val);
            if (!Number.isNaN(max)) validators.push(Validators.max(max));
            break;
          }
          case 'minlength': {
            const minLen = Number(val);
            if (!Number.isNaN(minLen)) validators.push(Validators.minLength(minLen));
            break;
          }
          case 'maxlength': {
            const maxLen = Number(val);
            if (!Number.isNaN(maxLen)) validators.push(Validators.maxLength(maxLen));
            break;
          }
        }
      });
    }

    return validators;
  }

 
  formatDateByPattern(value: string, pattern: string | null): string {
    if (!value || typeof value !== 'string') return value;

    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return value;

    const [, yyyy, mm, dd] = match;
    if (!pattern) return `${yyyy}${mm}${dd}`;

    const normalized = pattern.toUpperCase().replace(/A{4}/g, 'YYYY');

    switch (normalized) {
      case 'YYYYMMDD':   return `${yyyy}${mm}${dd}`;
      case 'YYYYMM':     return `${yyyy}${mm}`;
      case 'DDMMYYYY':   return `${dd}${mm}${yyyy}`;
      case 'YYYY-MM-DD': return `${yyyy}-${mm}-${dd}`;
      case 'DD-MM-YYYY': return `${dd}-${mm}-${yyyy}`;
      case 'YYYY-MM':    return `${yyyy}-${mm}`;
      default:           return `${yyyy}${mm}${dd}`;
    }
  }


  resolveAssociateText(structField: any, selectedValue: string): string | null {
    if (!structField?.associateField || structField.inputType !== 'select') return null;
    const options: any[] = structField.value || [];
    const found = options.find(o => String(o?.value) === String(selectedValue));
    return found?.text ?? found?.value ?? null;
  }


  getValidatorErrorMessage(control: AbstractControl, validatorsMeta: any[]): string {
    if (!control?.errors) return '';

    const msgMap: Record<string, string> = {};
    if (Array.isArray(validatorsMeta)) {
      validatorsMeta.forEach((v: any) => {
        const type = (v?.type || '').toString().trim().toLowerCase();
        const msg = (v?.msg || '').toString().trim();
        if (type && msg) msgMap[type] = msg;
      });
    }

    if (control.errors['required'])   return 'Este campo es requerido.';
    if (control.errors['pattern'])    return msgMap['pattern']    || 'El valor no cumple el formato esperado.';
    if (control.errors['min'])        return msgMap['min']        || 'El valor es menor al mínimo permitido.';
    if (control.errors['max'])        return msgMap['max']        || 'El valor es mayor al máximo permitido.';
    if (control.errors['minlength'])  return msgMap['minlength']  || 'El valor es más corto de lo permitido.';
    if (control.errors['maxlength'])  return msgMap['maxlength']  || 'El valor excede el largo permitido.';

    return 'Valor inválido.';
  }

  private toValidRegexPattern(value: any): string | null {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed || trimmed.toUpperCase() === 'AAAAMMDD') return null;
    try {
      new RegExp(trimmed);
      return trimmed;
    } catch {
      return null;
    }
  }
}
